define.alias("shared/components/shared/profile-categorization/banner", "calendar/components/shared/profile-categorization/banner");